// extracted by mini-css-extract-plugin
export default {"wrapper":"App_wrapper__Mru9Z","page":"App_page__5vKaD","footer":"App_footer__aawhi"};